import { instance } from '@/utils/request.utility';

export default class Workspace {
  static getWsList = async () => {
    try {
      const { data } = await instance({
        url: `workspaces/list/by-account`,
        method: 'GET',
      })
      return data;
    } catch (error) {
      throw error;
    }
  }

  static getWs = async ({ workspace_id }) => {
    try {
      const { data } = await instance({
        url: `workspaces/${workspace_id}/by-account`,
        method: 'GET',
        headers: {
          workspace_id: workspace_id,
        },
      })
      return data;
    } catch (error) {
      throw error;
    }
  }
}
